import React from 'react';

import ListSubheader from '@material-ui/core/ListSubheader';
interface Props {
  label?:string;
}
export const SubHeader:React.FC<Props> = ({label}) => {
  return <ListSubheader component="div">{label}</ListSubheader>;
};
